<script setup lang="ts">
/**
 * RinganRemah — padanan <CaRemah>, hanya menukar <UIcon> dengan SVG inline.
 *
 * Butir terakhir adalah halaman saat ini: sengaja TIDAK ditautkan (tautan ke
 * halaman yang sedang dibuka membingungkan pembaca layar) dan ditandai
 * aria-current="page".
 */
defineProps<{
  /** Pasangan [nama, path]; path kosong berarti halaman saat ini. */
  jejak: [string, string][]
}>()
</script>

<template>
  <nav aria-label="Remah roti" class="ca-caption text-muted">
    <ol class="flex flex-wrap items-center gap-1.5">
      <li v-for="(j, i) in jejak" :key="j[0]" class="flex items-center gap-1.5">
        <RinganIkon v-if="i > 0" nama="chevron-right" class="size-3.5 shrink-0 text-muted" />
        <NuxtLink
          v-if="j[1]"
          :to="j[1]"
          class="ca-focus rounded-control hover:text-brand underline-offset-2 hover:underline"
        >{{ j[0] }}</NuxtLink>
        <span v-else class="font-semibold text-ink" aria-current="page">{{ j[0] }}</span>
      </li>
    </ol>
  </nav>
</template>
